import { render, staticRenderFns } from "./CarsCreate.vue?vue&type=template&id=c5cb2fde"
import script from "./CarsCreate.vue?vue&type=script&lang=js"
export * from "./CarsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports